import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Create from "./Create";
import Edit from "./Edit";
import Categorias from "./Categorias";
import CargarVenta from "./CargarVenta"; // 1. Importamos el nuevo componente
import { CartContext } from "../context/CartContext";

const Show = ({ onLogout }) => {
  const { items, loadProducts, isLoading } = useContext(CartContext);
  const [searchTerm, setSearchTerm] = useState("");
  const [viewActive, setViewActive] = useState(true);
  const navigate = useNavigate();

  // 2. Estados para controlar el Modal de Venta
  const [showVenta, setShowVenta] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  useEffect(() => {
    loadProducts();
  }, []);

  // 3. Función para abrir el modal de venta
  const handleOpenVenta = (product) => {
    setSelectedProduct(product);
    setShowVenta(true);
  };

  const handleLogout = () => {
    localStorage.removeItem("isAdmin");
    onLogout();
    navigate("/");
  };

  const deleteProduct = async (id) => {
    const result = await Swal.fire({
      title: "¿Estás seguro?",
      text: "El producto y sus imágenes se eliminarán.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Sí, borrar",
      cancelButtonText: "Cancelar",
    });

    if (result.isConfirmed) {
      try {
        const resp = await fetch(
          "https://optimarketok.com.ar/api/delete_product.php",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id }),
            credentials: "include",
          },
        );
        const res = await resp.json();
        if (res.success) {
          await loadProducts();
          Swal.fire("Eliminado", "Producto borrado con éxito.", "success");
        } else {
          Swal.fire("Error", res.message || "No autorizado", "error");
        }
      } catch (error) {
        console.error("Error al borrar:", error);
      }
    }
  };

  const filteredProducts = items.filter((p) => {
    const matchesSearch =
      (p.titulo?.toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
      (p.categoria?.toLowerCase() || "").includes(searchTerm.toLowerCase());

    const isPausado = p.estado?.toLowerCase() === "pausado";
    const matchesTab = viewActive ? !isPausado : isPausado;

    return matchesSearch && matchesTab;
  });

  if (isLoading)
    return <div className="text-center mt-5">Cargando Administrador...</div>;

  return (
    <div className="container mt-4 pb-5">
      {/* HEADER */}
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-4 bg-white p-3 rounded shadow-sm border gap-3">
        <div className="d-flex align-items-center gap-2">
          <h2 className="h4 mb-0 text-dark me-3">Admin</h2>
          <Categorias />
          <Create />
        </div>

        <div className="input-group" style={{ maxWidth: "350px" }}>
          <span className="input-group-text bg-white border-end-0">
            <i className="bi bi-search text-muted"></i>
          </span>
          <input
            type="text"
            className="form-control border-start-0"
            placeholder="Buscar por título o categoría..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <button onClick={handleLogout} className="boton btn-outline-danger">
          <i className="bi bi-box-arrow-right me-2"></i>Salir
        </button>
      </div>

      {/* TABS */}
      <ul className="nav nav-tabs mb-3">
        <li className="nav-item" style={{ cursor: "pointer" }}>
          <span
            className={`nav-link ${viewActive ? "active fw-bold text-primary" : "text-muted"}`}
            onClick={() => setViewActive(true)}
          >
            Activos (
            {items.filter((p) => p.estado?.toLowerCase() !== "pausado").length})
          </span>
        </li>
        <li className="nav-item" style={{ cursor: "pointer" }}>
          <span
            className={`nav-link ${!viewActive ? "active fw-bold text-danger" : "text-muted"}`}
            onClick={() => setViewActive(false)}
          >
            Pausados (
            {items.filter((p) => p.estado?.toLowerCase() === "pausado").length})
          </span>
        </li>
      </ul>

      {/* TABLA */}
      <div className="table-responsive shadow-sm rounded border bg-white">
        <table className="table table-hover mb-0 ">
          <thead className="table-secondary">
            <tr>
              <th style={{ width: "80px" }}>Imagen</th>
              <th>Título</th>
              <th>Categoría</th>
              <th>Precio</th>
              <th>Stock</th>
              <th className="text-center">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {filteredProducts.map((product) => {
              // Lógica de imagen (se mantiene igual...)
              let primerNombre = "";
              if (product.imagenes) {
                try {
                  const parsed =
                    typeof product.imagenes === "string"
                      ? JSON.parse(product.imagenes)
                      : product.imagenes;
                  const item = Array.isArray(parsed) ? parsed[0] : parsed;
                  primerNombre =
                    typeof item === "object" && item !== null
                      ? item.name || item.url
                      : String(item);
                } catch (e) {
                  primerNombre = String(product.imagenes);
                }
              }
              const srcImagen =
                primerNombre && primerNombre !== "[object Object]"
                  ? primerNombre.startsWith("http")
                    ? primerNombre
                    : `https://optimarketok.com.ar/imagenes/${encodeURIComponent(primerNombre.trim())}`
                  : null;

              return (
                <tr key={product.id} className="align-middle">
                  <td>
                    <div
                      style={{ width: "55px", height: "55px" }}
                      className="rounded border bg-light d-flex align-items-center justify-content-center overflow-hidden"
                    >
                      {srcImagen ? (
                        <img
                          src={srcImagen}
                          alt=""
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <i className="bi bi-image text-muted"></i>
                      )}
                    </div>
                  </td>
                  <td className="fw-bold">{product.titulo}</td>
                  <td>
                    <span className="badge bg-light text-dark border">
                      {product.categoria}
                    </span>
                  </td>
                  <td className="text-success fw-bold">
                    ${Number(product.precio || 0).toLocaleString("es-AR")}
                  </td>
                  <td>{product.stock} un.</td>
                  <td>
                    <div className="d-flex justify-content-center gap-3 align-items-center">
                      {/* 4. BOTÓN DE VENTA (Solo para productos con stock) */}
                      <button
                        className="btn btn-link text-success p-0 border-0"
                        onClick={() => handleOpenVenta(product)}
                        title="Registrar Venta"
                      >
                        <i className="bi bi-cart-plus fs-5"></i>
                      </button>

                      <Edit productData={product} />

                      <button
                        onClick={() => deleteProduct(product.id)}
                        className="btn btn-link text-danger p-0 border-0"
                      >
                        <i className="bi bi-trash fs-5"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* 5. COMPONENTE MODAL DE VENTA */}
      {selectedProduct && (
        <CargarVenta
          show={showVenta}
          handleClose={() => setShowVenta(false)}
          productData={selectedProduct}
        />
      )}
    </div>
  );
};

export default Show;
